var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvertimeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.9961C22 17.5189 17.5228 21.9961 12 21.9961C6.47715 21.9961 2 17.5189 2 11.9961C2 6.47324 6.47715 1.99609 12 1.99609C17.5228 1.99609 22 6.47324 22 11.9961Z",
    fill: "#384573"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 7.25391C12.4152 7.25391 12.751 7.5897 12.751 8.00391V11.6932L15.0313 13.9736C15.3242 14.2665 15.3242 14.7413 15.0313 15.0342C14.7384 15.3271 14.2636 15.3271 13.9707 15.0342L11.4707 12.5342C11.33 12.3936 11.251 12.2028 11.251 12.0039V8.00391C11.251 7.5897 11.5868 7.25391 12.001 7.25391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertimeicon);
export default __webpack_public_path__ + "static/media/overtimeicon.0bd3c4d5ebbd98c1eb511b7c17682157.svg";
export { ForwardRef as ReactComponent };